/**
 * useScanVisibility - preference LOCALE (localStorage) d affichage des blocs de
 * scan sur le dashboard. Choix produit : toggle purement visuel cote navigateur
 * (pas de persistance backend) - il masque/affiche les blocs M365 / Azure et le
 * detail M365 du dashboard, mais n affecte PAS les scans planifies ni le score.
 *
 * Synchronise entre composants via un event window custom (les 2 blocs + le
 * DashboardPage lisent le meme etat sans prop-drilling).
 */
import { useEffect, useState } from 'react';

const KEY_M365  = 'nis365.dash.m365Enabled';
const KEY_AZURE = 'nis365.dash.azureEnabled';
const EVT       = 'nis365-scan-visibility-change';

// Defaut = active (true) tant que la cle n est pas '0'.
function read(key: string): boolean {
  try { return localStorage.getItem(key) !== '0'; } catch { return true; }
}
function write(key: string, value: boolean): void {
  try { localStorage.setItem(key, value ? '1' : '0'); } catch { /* quota / private mode */ }
  window.dispatchEvent(new Event(EVT));
}

export function useScanVisibility() {
  const [m365,  setM365State]  = useState<boolean>(() => read(KEY_M365));
  const [azure, setAzureState] = useState<boolean>(() => read(KEY_AZURE));

  useEffect(() => {
    const sync = () => { setM365State(read(KEY_M365)); setAzureState(read(KEY_AZURE)); };
    window.addEventListener(EVT, sync);
    window.addEventListener('storage', sync);   // sync inter-onglets
    return () => { window.removeEventListener(EVT, sync); window.removeEventListener('storage', sync); };
  }, []);

  return {
    m365,
    azure,
    setM365:  (v: boolean) => write(KEY_M365,  v),
    setAzure: (v: boolean) => write(KEY_AZURE, v),
  };
}
